import * as types from './Types.js';

const resource = '/protocolo/config';

export function fetchConfig() {
  return ({ fetch }) => ({
    type: types.FETCH_CONFIG,
    payload: {
      promise: fetch(resource)
    }
  });
}

export function fetchConfigIsNotLoggedWithEntidade(pathRepresentaEntidade) {
  const url = pathRepresentaEntidade
    ? `${resource}/${pathRepresentaEntidade}`
    : resource;

  return ({ fetch }) => ({
    type: types.FETCH_CONFIG,
    payload: {
      promise: fetch(url)
    }
  });
}
